import { useContext, useState } from "react";
import { useWriteOffMutation } from "../../../hooks/api/mutations/useCustomer";
import { cleanObject, getRandomIntInclusive } from "../../../helpers";
import { RequestLoader, ToastContext } from "../../../hooks/context";

const useWriteOff = ({
  closeModal = () => {},
  customer,
  onSuccess = () => {},
  fetchCustomer = () => {},
}) => {
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const triggerToast = useContext(ToastContext);
  const [details, setDetails] = useState({
    amount: "",
    note: "",
    write_off_at: "",
  });
  const updateWriteOff = useWriteOffMutation();
  // write off
  const handleUpdate = () => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 50));
    const data = cleanObject({ ...details });
    updateWriteOff.mutate(
      { id: customer?.id, data },
      {
        onSuccess: () => {
          onSuccess();
          fetchCustomer();
          triggerToast("Customer write off updated successfully", "success");
          closeModal();
        },

        onSettled: () => setRequestLoaderProgress(100),
      },
    );
  };

  return {
    details,
    setDetails,
    handleUpdate,
    updateWriteOff,
  };
};
export default useWriteOff;
